import React from 'react'
import {User} from '../../core/_models'
import {FC} from 'react'
type Props = {
    user: User
}
    

const AppliedWorkerContactCell: FC<Props> = ({user}) =>{
    // console.log("🚀 ~ file: UserContactCell.tsx:7 ~ user", user.phone)
    return (
    <div>
        {user.phone}
        <div>
            {user.email}
        </div>
    </div>
    )
}

export  {AppliedWorkerContactCell}